import { EventsData } from '../types/types';

export type TipoResultado = 'Grupos' | 'Eventos' | 'Recintos' | 'Provincias' | 'Localidades';

export type ResultadoBusqueda = {
  tipo: TipoResultado,
  id: string,
  title: string
};

// Cada plataforma lista los grupos de resultados en un orden distinto, y el que
// queda marcado tiene que ser el primero que se ve.
export const TIPOS_RESULTADO_DESKTOP: TipoResultado[] = ['Grupos', 'Eventos', 'Recintos', 'Provincias', 'Localidades'];
export const TIPOS_RESULTADO_MOBILE: TipoResultado[] = ['Eventos', 'Grupos', 'Recintos', 'Provincias', 'Localidades'];

type ItemResultado = { id: string, title: string, category: string };

const itemsDelTipo = (resultado: EventsData[number], tipo: TipoResultado): ItemResultado[] => {
  switch (tipo) {
    case 'Grupos':
      return resultado.grupos || [];
    case 'Eventos':
      return resultado.events || [];
    case 'Recintos':
      return resultado.recintos || [];
    case 'Provincias':
      return resultado.provincias || [];
    case 'Localidades':
      return resultado.localidades || [];
  }
};

// Aplana los resultados del buscador a una unica lista ordenada, para poder
// marcar y recorrer los resultados con el teclado.
export const flattenResultadosBusqueda = (
  resultadosBusqueda: EventsData | null,
  tipos: TipoResultado[]
): ResultadoBusqueda[] => {
  if (!resultadosBusqueda) {
    return [];
  }

  return resultadosBusqueda.reduce((acc: ResultadoBusqueda[], resultado) => {
    tipos.forEach((tipo) => {
      itemsDelTipo(resultado, tipo).forEach((item) => {
        acc.push({ tipo, id: item.id, title: item.title });
      });
    });

    return acc;
  }, []);
};

// Misma navegacion que hace ResultadosBusqueda al clickear un resultado.
export const pathResultadoBusqueda = ({ tipo, id }: ResultadoBusqueda): string => {
  switch (tipo) {
    case 'Provincias':
      return `/eventos?p=${id}`;
    case 'Recintos':
      return `/eventos?pl=${id}`;
    case 'Eventos':
      return `/evento/${id}/step/1`;
    case 'Localidades':
      return `/eventos?lo=${id}`;
    case 'Grupos':
      return `/eventos?group=${id}`;
  }
};
